<template>
  <SMDialog ref="dialog">
    <template #header>{{ mdTitle }}</template>
    <template #content><div v-html="mdContentHtml"></div></template>
    <template #actions="{ close }">
      <button
        v-if="mdCancelText"
        class="px-2 py-1.5 bg-blue-500 text-white rounded hover:bg-blue-600"
        @click="onClose('cancel', close)"
      >
        {{ mdCancelText }}
      </button>
      <button class="px-2 py-1.5 bg-blue-500 text-white rounded hover:bg-blue-600" @click="onClose('ok', close)">
        {{ mdOkText }}
      </button>
    </template>
  </SMDialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import SMDialog from './SMDialog.vue';

defineProps({
  mdTitle: String,
  mdContentHtml: String,
  mdOkText: String,
  mdCancelText: String,
});

const emit = defineEmits(['close']);

const onClose = (action: 'ok' | 'cancel', close: () => void) => {
  emit('close', action);
  close();
};

const dialog = ref<InstanceType<typeof SMDialog>>();

defineExpose({
  open: () => dialog.value?.open(),
  close: () => dialog.value?.close(),
});
</script>
